export { default as ColorfulButton } from './components/colorful-button';
export { default as ColorfulInput } from './components/colorful-input';
export { default as ColorfulText } from './components/colorful-text';
const bizCssPrefix = 'bizpack';
export { bizCssPrefix };
